import { render, staticRenderFns } from "./BarEchartsHor.vue?vue&type=template&id=256e8020"
import script from "./BarEchartsHor.vue?vue&type=script&lang=js"
export * from "./BarEchartsHor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports